<template>
    <b-modal
            v-model="modal.state"
            @hidden="hideModal"
            modal-class="claim-your-home-modal"
            centered
            size="xl"
            hide-header-close
            hide-header
            no-close-on-esc
            no-close-on-backdrop
    >
        <div>
            <div class="tw-flex tw-justify-between tw-mb-8 lg:tw-mb-0 lg:tw-justify-end">
                <button
                        v-if="isMobile"
                        class="new-ui-kit-button-small-tertiary-icon"
                        @click="hideModal"
                >
                    <i class="fa-solid fa-arrow-left tw-mr-2"></i>
                    Back
                </button>
                <button
                        v-if="showSignInBtn"
                        class="new-ui-kit-button-small-secondary"
                        :style="{'color':computedPrimaryColor}"
                        @click="handleActionBtnClick"
                >
                    Sign In
                </button>
            </div>
            <address-card
                    :address="address"
                    :property-image="propertyImage"
                    :computed-primary-color="computedPrimaryColor"
            />
        </div>

        <h1 class="claim-your-home-modal-title tw-font-bold">
            Claim Your Home
        </h1>
        <claim-your-home-form
                v-model="form"
                :errors="formErrors"
                :disabled="loading"
                :user-exists="userExists"
                @clear-errors="clearErrors"
        />
        <div class="tw-mt-1">
            <b-link
                    v-if="userExists && passwordIncorrect"
                    class="claim-your-home-modal-forgot-pass tw-text-base tw-underline tw-mt-2.5 tw-font-semibold"
                    :style="{'color':computedPrimaryColor}"
                    @click="handleForgotPasswordClick"
            >
                Forgot Password
            </b-link>
        </div>

        <template #modal-footer="{close}">
            <div class="tw-flex">
                <b-button
                        class="btn-exit tw-flex tw-justify-center tw-items-center"
                        variant="transparent"
                        size="lg"
                        @click="close"
                >
                    Cancel
                </b-button>

                <b-button
                        class="btn-save tw-flex tw-justify-center tw-items-center"
                        variant="primary"
                        :style="{'background-color':computedPrimaryColor, 'border-color': computedPrimaryColor}"
                        size="lg"
                        @click="handleSubmit"
                >
                    Claim Home
                </b-button>
            </div>

            <div class="modal-disclaimer">
                By continuing, you accept our
                <b-link
                        class="text-link"
                        target="_blank"
                        :href="termsOfUse"
                >
                    Terms of Use
                </b-link>
                and
                <b-link
                        class="text-link"
                        target="_blank"
                        :href="privacyPolicy"
                >
                    Privacy Policy
                </b-link>
            </div>
        </template>
    </b-modal>
</template>

<script>
import './ClaimYourHomeModal.scss';
import AddressCard from "../../AddressCard/AddressCard";
import ClaimYourHomeForm from "./ClaimYourHomeForm/ClaimYourHomeForm";
import axios from "axios";
import {
    newProjectUrl, redirectTo,
} from "../../../helpers/externalRoutes";
import {privacyPolicy, termsOfUse} from "@milestoneslabs/milestones-ui-kit/src/helpers/externalLinks";
import HttpResponseCodes from "@milestoneslabs/milestones-unified-login/src/HttpResponseCodes";
import {mapActions, mapState} from "vuex";
import isEmpty from 'lodash/isEmpty';
import debounce from 'lodash/debounce';
import MomentTimezone from "moment-timezone";
import {getRedirectLinkToNewProject} from "../../../../helpers/modals";
import ShowNotificationMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/ShowNotificationMixin";
import InternalFormErrorsMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/InternalFormErrorsMixin";
import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";


export const CLAIM_YOUR_HOME_MODAL_OPEN = 'CLAIM_YOUR_HOME_MODAL_OPEN';

export default {
    name: "ClaimYourHomeModal",
    components: {
        ClaimYourHomeForm,
        AddressCard
    },
    mixins: [
        ShowNotificationMixin,
        InternalFormErrorsMixin,
        IsMobileMixin
    ],
    props: {
        landingPagePrimaryColor: {
            type: String,
            default: '#3D465E'
        },
    },
    data() {
        return {
            propertyImage: '',
            form: {
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                password: '',
                landingPageUuid: window.landingPageUuid,
            },
            formErrors: {},
            loading: false,
            termsOfUse,
            privacyPolicy,
            modal: {
                state: false,
                termsAccepted: false,
            },
            address: {},
            HOHProjectTypeUuid: '',
            userExists: false,
            checkingEmail: false,
            passwordIncorrect: false,
            brandingColor: window.organizationBranding.primaryColor,
        };
    },
    computed: {
        ...mapState({
            authUser: state => state.landingPage.authUser
        }),
        authHost() {
            let authHost = new URL(window.env.MILESTONES_AUTH_HOST);
            return window.location.protocol + '//' +
                authHost.host;
        },
        showSignInBtn() {
            return !Boolean(this.authUser?.uuid);
        },
        userScenario() {
            let scenario = 'new-user';
            if (this.userExists) {
                scenario = 'existing-user';
            }
            return scenario;
        },
        validationRules() {
            let rules = {
                email: {
                    type: 'string',
                    presence: {
                        message: 'is required!'
                    },
                    email: true,
                },
                phone: {
                    phoneNumber: {
                        country: 'US',
                    },
                },
                password: {
                    presence: true,
                    length: {
                        minimum: 1,
                        maximum: 255,
                        tooShort: 'is required!'
                    }
                },
                firstName: {},
                lastName: {},
            };

            if (this.userScenario === 'new-user') {
                rules.firstName = {
                    type: 'string',
                    presence: true,
                    length: {
                        minimum: 1,
                        maximum: 255,
                        tooShort: 'is required!'
                    }
                };
                rules.lastName = {
                    type: 'string',
                    presence: true,
                    length: {
                        minimum: 1,
                        maximum: 255,
                        tooShort: 'is required!'
                    }
                };
            }
            return rules;
        },
        computedPrimaryColor() {
            if (this.landingPagePrimaryColor !== '#3D465E') {
                return this.landingPagePrimaryColor;
            }

            return this.brandingColor;
        }
    },
    methods: {
        ...mapActions({
            setAuthUser: 'setAuthUser'
        }),
        async handleForgotPasswordClick() {
            this.loading = true;
            let url = this.authHost + '/password/email';
            try {
                await axios.post(url, {
                    email: this.form.email,
                    _token: window.env.CSRF_TOKEN
                });
                this.showNotification({
                    message: 'Thanks! Check your email to reset your password.',
                    type: 'success',
                });
            } catch (error) {
                const response = error.response.data;
                const {status} = response;
                switch (status) {
                    case HttpResponseCodes.HTTP_BAD_REQUEST:
                        if (response.errors.hasOwnProperty('email')) {
                            this.formErrors.email = response.errors.email;
                        }
                        break;
                }
            } finally {
                this.loading = false;
            }
        },
        handleActionBtnClick() {
            redirectTo(getRedirectLinkToNewProject({
                brandedLogin: window.brandedLogin,
                type: this.HOHProjectTypeUuid,
                hohAddress: btoa(JSON.stringify(this.address.attributes)),
                landingPageUuid: window.landingPageUuid,
            }));
        },
        async onClaimYourHomeModalOpen({address, propImgSrc, HOHProjectTypeUuid, hohEmail, landingPage}) {
            if (!address) {
                throw new Error('Address is required');
            }
            if (!HOHProjectTypeUuid) {
                throw new Error('HOHProjectTypeUuid is required');
            }

            this.address = address;
            this.propertyImage = propImgSrc;
            this.HOHProjectTypeUuid = HOHProjectTypeUuid;
            if (hohEmail) {
                this.form.email = hohEmail;
                await this.getUserOrContactByEmail(hohEmail, landingPage.userUuid);
            }
            if (this.form.email) {
                await this.checkEmail(this.form.email);
            }
            this.modal.state = true;

        },
        async getUserOrContactByEmail(email, landingPageUserUuid) {
            let url = this.authHost + '/user-or-contact/by-email';
            await axios.post(url, {
                email: email,
                landingPageUserUuid: landingPageUserUuid
            }).then((response) => {
                const data = response.data.data;
                this.form.firstName = data.firstName;
                this.form.lastName = data.lastName;
                this.form.phone = data.phone;
            }).catch((e) => console.warn(e));
        },
        hideModal() {
            this.modal.state = false;
            this.address = {};
            this.propertyImage = '';
            this.form = {
                firstName: '',
                lastName: '',
                email: '',
                password: '',
                landingPageUuid: '',
            };
            this.formErrors = {};
            this.loading = false;
        },
        async handleSubmit() {
            if (this.checkingEmail) {
                return;
            }

            if (this.userScenario === 'new-user') {
                this.clearErrors('lastName');
                this.clearErrors('firstName');

                this.validateUserCredentials();
            }

            const errors = this.formErrors;
            this.formErrors = this.$validate(this.form, this.validationRules) || {};
            this.formErrors = Object.assign(this.formErrors, errors);

            if (!isEmpty(this.formErrors)) {
                return;
            }

            if (this.userExists) {
                this.loading = true;
                try {
                    let loginResp = await this.login();
                    if (loginResp) {
                        window.location = newProjectUrl({
                            type: this.HOHProjectTypeUuid,
                            hohAddress: btoa(JSON.stringify(this.address.attributes)),
                            landingPageUuid: window.landingPageUuid,
                        });
                    }
                } catch (e) {
                    console.warn(e);
                } finally {
                    this.loading = false;
                }
            }
            if (!this.userExists) {
                this.loading = true;
                try {
                    let registerResp = await this.register();
                    if (registerResp) {
                        window.location = newProjectUrl({
                            type: this.HOHProjectTypeUuid,
                            hohAddress: btoa(JSON.stringify(this.address.attributes)),
                            landingPageUuid: window.landingPageUuid,
                        });
                    }
                } catch (e) {
                    console.warn(e);
                } finally {
                    this.loading = false;
                }
            }
        },
        async login() {
            let url = this.authHost + '/login';
            try {
                await axios.post(url,
                                 {
                                     email: this.form.email,
                                     password: this.form.password,
                                     _token: window.env.CSRF_TOKEN,
                                 },
                );
                this.setAuthUser();
                return true;
            } catch (error) {
                const response = error.response.data;
                const {status} = response;
                switch (status) {
                    case HttpResponseCodes.HTTP_BAD_REQUEST:
                        if (response.errors.hasOwnProperty('email')) {
                            this.passwordIncorrect = true;
                            this.formErrors.password = [
                                'Incorrect password.'
                            ];
                        }
                        break;
                }
            }
            return false;
        },
        async checkEmail(email) {
            this.userExists = false;
            this.passwordIncorrect = false;
            this.checkingEmail = true;
            this.$delete(this.formErrors, 'password');

            let url = this.authHost + '/login/check';
            try {
                await axios.post(url, {
                    email: email
                });
                this.userExists = true;
            } catch (error) {
                const response = error.response.data;
                const {status} = response;

                switch (status) {
                    case HttpResponseCodes.HTTP_NOT_FOUND:
                        this.userExists = false;
                        break;
                    case HttpResponseCodes.HTTP_BAD_REQUEST:
                        this.userExists = false;
                        // this.formErrors.email = response.errors.email;
                        break;
                    case HttpResponseCodes.HTTP_OK:
                        this.userExists = true;
                        break;
                    // case HttpResponseCodes.HTTP_UNAUTHORISED:
                    //     this.userExists = true;
                    //     this.userIsDisabled = true;
                    //     this.errors.user = response.errors.user;
                    //     break;
                }
            } finally {
                this.checkingEmail = false;
            }
        },
        async register() {
            let url = this.authHost + '/register';
            try {
                await axios.post(url, {
                    email: this.form.email,
                    password: this.form.password,
                    firstName: this.form.firstName,
                    lastName: this.form.lastName,
                    _token: window.env.CSRF_TOKEN,
                    timezone: MomentTimezone.tz.guess(true),
                });
                this.setAuthUser();
                return true;
            } catch (e) {
                console.warn(e);
            }
            return false;
        }
    },

    watch: {
        'form.email': {
            async handler(newVal) {
                await this.checkEmail(newVal);
            }
        }
    },
    async mounted() {
        this.checkEmail = debounce(this.checkEmail, 1000);
    },

    beforeMount() {
        this.$bus.$on(CLAIM_YOUR_HOME_MODAL_OPEN, this.onClaimYourHomeModalOpen);
    },

    beforeDestroy() {
        this.$bus.$off(CLAIM_YOUR_HOME_MODAL_OPEN, this.onClaimYourHomeModalOpen);
    }
};
</script>
